import styled, { css } from 'styled-components';
import listStyled from 'components/List/styles';
import {
  SPACING_0,
  SPACING_16,
  SPACING_8,
  SPACING_24,
  SPACING_4,
  SPACING_64,
  SPACING_48,
  SPACING_14
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import {
  SHADOW_SPREAD_2
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/shadow_spread';
import {
  KINGFISHER_BLUE_400,
  BLACK,
  NEUTRAL_GREY_10,
  NEUTRAL_GREY_50
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/colors';
import {
  LINE_HEIGHT_TIGHT,
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/lineHeight';
import { CAPTION } from '@nokia-csf-uxr/freeform-design-tokens/tokens/typography';
import { DEEP_BORDER_BOX } from 'common';

const SPACING_54 = '3.375rem';
const SPACING_56 = '3.5rem';

const BreadcrumbMainText = styled.div`
line-height: ${LINE_HEIGHT_TIGHT};
color: ${props => props.$theme.title};
white-space: nowrap;
user-select: none;
overflow: hidden;
text-overflow: ellipsis;
${props =>
    css`
    direction: ${props.RTL ? 'rtl' : 'ltr'};
  `}
`;

const getBreadcrumbCommonStyle = props => css`
  height: 100%;
  display: flex;
  overflow-x: hidden;
  ${!(props.RTL || props.$rtl || props.rtl) ? 'flex-direction: row;' : 'flex-direction: row-reverse;'}
  text-decoration: none;
  text-decoration: none;
  ${!props.disabled ? 'cursor: pointer;' : 'cursor: default;'}
  outline: none;
  &:focus {
    ${!props.disabled && `box-shadow: inset 0 0 0 ${SHADOW_SPREAD_2} ${props.$theme.focus.border};`}
  }
  &:hover {
    ${!props.disabled && `background-color: ${props.$theme.hover.background};`}
  }
  &:active {
    ${!props.disabled && `background-color: ${props.$theme.pressed.background};`}
    ${BreadcrumbMainText} {
      ${!props.disabled && `color: ${props.$theme.pressed.content};`}
    }
  }
`;
export default {
  Wrapper: styled.nav`
    ${DEEP_BORDER_BOX}
    height: ${SPACING_64};
    width: auto;
    display: inline-flex;
    background-color: ${props => props.$theme.background};
    box-shadow: 0 ${SPACING_4} ${SPACING_4} 0 ${BLACK}3D, 0 0 ${SPACING_4} 0 ${BLACK}1F;
  `,
  NavItemsWrapper: styled.ol`
    display: inline-flex;
    margin: 0;
    ${({ RTL }) => RTL ? css`
      padding: ${SPACING_0} ${SPACING_16} ${SPACING_0} ${SPACING_0};
    ` : css`
      padding: ${SPACING_0} ${SPACING_0} ${SPACING_0} ${SPACING_16};
    `};
    ${props =>
    !props.RTL
      ? css`
            flex-direction: row;
          `
      : css`
            flex-direction: row-reverse;
          `}
  `,
  BreadcrumbWrapper: styled.li`
    height: ${SPACING_64};
  `,
  BreadcrumbLinkWrapper: styled.a`
    ${props => getBreadcrumbCommonStyle(props)}
  `,
  BreadcrumbNormalWrapper: styled.div`
    ${props => getBreadcrumbCommonStyle(props)}
  `,
  BreadcrumbTextContainer: styled.div`
    padding: ${SPACING_0} ${SPACING_8};
    ${({ $isCompact, $rtl }) => $isCompact && ($rtl ? css`
      padding: ${SPACING_0} ${SPACING_8} ${SPACING_0} ${SPACING_0};
    ` : css`
      padding: ${SPACING_0} ${SPACING_0} ${SPACING_0} ${SPACING_8};
    `)};
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    margin-top: -0.0625rem; // to move text up due to line-height adjustment
  `,
  BreadcrumbSecondText: styled.div`
    ${CAPTION}
    color: ${props => props.$theme.subtitle};
    white-space: nowrap;
    user-select: none;
    overflow: hidden;
    text-overflow: ellipsis;
    ${props =>
    css`
        direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};
      `}
  `,
  BreadcrumbIcon: styled.div`
    margin: auto ${SPACING_4};
    width: ${SPACING_24};
    height: ${SPACING_24};
  `,
  LinkSeparator: styled.div`
    display: inline-flex;
    align-items: center;
    user-select: none;
  `,
  CompactWrapper: styled.div`
    display: inline-block;
    position: relative;
  `,
  HeaderWrapper: styled.div`
    display: flex;
    height: 100%;
    align-items: center;
  `,
  HeaderBreadCrumb: styled.div`
    display: flex;
    & > div {
      margin: auto;
    }
  `,
  ListHeadingItem: styled.li`
    box-sizing: border-box;
    height: ${SPACING_48};m
    whitespace: nowrap;
    padding: ${SPACING_4} ${SPACING_24} ${SPACING_4} ${SPACING_16};
    background-color: ${NEUTRAL_GREY_10};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    overflow: initial;
    outline: none;
    cursor: default;
    user-select: none;
    &:focus {
      ${props => !props.disabled && `box-shadow: inset 0 0 0 ${SHADOW_SPREAD_2} ${KINGFISHER_BLUE_400};`}
    }
    &:hover {
      background: ${NEUTRAL_GREY_50};
      cursor: pointer;
    }
  `,
  BreadcrumbCompactsListHeaderWrapper: styled.div`
    & > li {
      height: ${SPACING_64};
      padding-left: ${SPACING_16};
    }
    & > li:focus {
      padding-left: ${SPACING_14};
    }
  `,
  BreadcrumbCompactsListItem: styled.div`
  background-color: transparent;

  ${listStyled.ListItemBasic} {
    padding: ${SPACING_4} ${SPACING_8} ${SPACING_4} ${SPACING_56};
    ${({ $rtl }) => $rtl && css`
      padding: ${SPACING_4} ${SPACING_56} ${SPACING_4} ${SPACING_8};
    `};
    :focus {
      padding: ${SPACING_4} ${SPACING_8} ${SPACING_4} ${SPACING_54};
      ${({ $rtl }) => $rtl && css`
        padding: ${SPACING_4} ${SPACING_54} ${SPACING_4} ${SPACING_8};
      `};
    }
    :hover {
      background-color: ${({ $theme }) => $theme && $theme.hover.background};
    }
  }
`,
  BreadcrumbMainText,
};
